// extracted by mini-css-extract-plugin
module.exports = {"overlay":"LineupCamOverlay_overlay__pazee","background":"LineupCamOverlay_background__d_maa","corner":"LineupCamOverlay_corner__ucKru","pill":"LineupCamOverlay_pill__qfPKR"};